import React, { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useTranslation } from "react-i18next";
import { Row, Col, Flex } from 'antd';
import { Text } from '../../../../Atomics/Text';
import { Widget } from "../../../../Atomics/Widget";
import useFetch from "../../../../../../server/useFetch";
import query from "../../../../../../server/constants.api";

export const BuildingGasConsumption = ({ dataToFilter, gasRef, hasGasConsumption, isGasConsumptionLoading }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  //const [dataGasConsumptionEnergy, setDataGasConsumption] = useState(null);
  //Make calls to obtain data using a custom hook ( useFecth ) and stored in variables. This calls are asynchronous 
  const { data: gasConsumptionData, isLoading: gasConsumptionIsLoading, refetch: refetchGasConsumptionData } =
    useFetch(query.path.detailGasConsumption, 'getDetailGasConsumption', { id: id, filters: JSON.stringify(dataToFilter) });

  let dataGasConsumptionEnergy = {
    "gasConsumption": {
      "number": 30.82,
      "unit": "MWh",
      "type": null,
      "label": null,
      "fluctuation": null,
      "fluctuationText": "fluctuation ",
      "bigFluctuation": false,
      "icon": "Gas"
    },
    "associatedEmissions": {
      "number": 6.2,
      "unit": "tCO2eq",
      "type": null,
      "label": null,
      "fluctuation": null,
      "fluctuationText": "fluctuation ",
      "bigFluctuation": false,
      "icon": "Emissions"
    },
    "gas": {
      "series": [
        {
          "name": 2024,
          "data": [
            {
              "x": "08/01/2024",
              "y": 6.493
            },
            {
              "x": "05/03/2024",
              "y": 12.623
            },
            {
              "x": "16/04/2024",
              "y": 5.141
            },
            {
              "x": "08/05/2024",
              "y": 6.559
            }
          ],
          "unit": "MWh"
        }
      ],
      "categories": [],
      "xAxisType": null,
      "labelFormat": "Monthly",
      "tooltip": null,
      "unit": "MWh",
      "columnWidth": 20,
      "yAxisLabel": "MWh",
      "xAxisLabel": null,
      "colors": null,
      "filename": "Gráfico exportado",
      "headerValue": "valores",
      "headerCategory": "categorias",
      "showTooltipTitle": false
    }
  }

  /*     useEffect(() => {
        isGasConsumptionLoading(gasConsumptionIsLoading)
      }, [gasConsumptionIsLoading]); */

  /*  useEffect(() => {
     if (gasConsumptionData?.data) {
       setDataGasConsumption(gasConsumptionData?.data)
       hasGasConsumption(gasConsumptionData?.data)
     }
   }, [gasConsumptionData?.data]);
 
   useEffect(() => {
     hasGasConsumption(null)
     refetchGasConsumptionData();
   }, [dataToFilter]); */

  return (
    <Flex id='Gas Consumption' className='ant-anchors-content-item' gap={32} vertical="true">
      <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('Gas Consumption')}</Text>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Flex gap={16} vertical='true'>
            <Widget data={{
              height: '150px',
              background: 'white',
              title: t('Gas Consumption'),
              icon: 'Gas',
              charts: [{
                chartType: 'bigNumberChart',
                chartId: 'mixBarChartOne',
                data: dataGasConsumptionEnergy?.gasConsumption
              }]
            }} />
            <Widget data={{
              height: '150px',
              background: 'white',
              title: t('Associated GEE Emissions'),
              icon: 'Emissions',
              charts: [{
                chartType: 'bigNumberChart',
                chartId: 'mixBarChartOne',
                data: dataGasConsumptionEnergy?.associatedEmissions
              }]
            }} />
          </Flex>
        </Col>
        <Col span={18}>
          <div ref={gasRef}>
            <Widget data={{
              height: '316px',
              background: 'white',
              title: 'Gás',
              icon: 'Gas',
              charts: [{
                chartType: 'columnsChartApex',
                data: dataGasConsumptionEnergy?.gas,
                height: '260px'
              }]
            }} />
          </div>
        </Col>

      </Row>
    </Flex>
  )
}